/**
 * @module GenerateMagnoliaPageJSON
 */

/**
 * Convenience function to generate JSON page data.
 */
const GenerateMagnoliaPageJSON = ({
  componentProps,
  componentType = 'locationdetail',
  ogOverrides = {
    description: '',
    facebook: '',
    keywords: '',
    ogTitle: '',
    title: '',
    twitter: '',
  },
  pageBaseOverrides = {},
  pageTemplate = 'lifechurch:pages/lifechurchbase',
  path,
  worshipSubNav = false,
}) => {
  const componentTypes = {
    locationdetail: 'locationID',
    mediacollection: 'mediaCollectionID',
    mediadetail: 'mediaID',
    talkitoverdetail: 'talkItOverID',
  };

  const idKey =
    componentTypes && componentTypes[componentType]
      ? componentTypes[componentType]
      : 'id';
  const nodeType =
    (pageBaseOverrides && pageBaseOverrides['@nodeType']) || 'mgnl:page';

  const pageBase = {
    '@id': `id-${componentProps['@id']}`,
    '@name': `${componentProps.name}`,
    '@nodes': ['main'],
    '@nodeType': nodeType,
    '@path': `${path}`,
    componentProps,
    displayNavBar: !worshipSubNav ? 'false' : 'true',
    enableLiveStatus: 'false',
    facebook_og_image: `${ogOverrides.facebook}`,
    main: {
      '@id': `${componentProps['@id']}`,
      '@name': 'main',
      '@nodes': ['0'],
      '@nodeType': 'mgnl:area',
      '@path': `${path}/main`,
      0: {
        ...componentProps,
        '@nodeType': 'mgnl:component',
        [idKey]: `${componentProps['@id']}`,
        'mgnl:template': `lifechurch:components/${componentType}`,
      },
      'mgnl:created': '2021-02-20T15:35:55.251-05:00',
      'mgnl:lastModified': '2021-02-20T15:36:04.274-05:00',
    },
    'mgnl:created': '2021-02-20T15:35:46.550-05:00',
    'mgnl:lastModified': '2021-02-20T15:36:04.274-05:00',
    'mgnl:template': pageTemplate,
    ogTitle: `${ogOverrides.ogTitle}`,
    seoDescription: `${ogOverrides.description}`,
    seoKeywords: `${ogOverrides.keywords}`,
    title: ogOverrides.title ? ogOverrides.title : componentProps.name,
    twitter_og_image: `${ogOverrides.twitter}`,
    worshipSubNav: !worshipSubNav ? 'false' : 'true',
  };
  return pageBase;
};

module.exports = {
  GenerateMagnoliaPageJSON,
};
